"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _string = require("../type-checks/string");

var setCustomError = function setCustomError(elementA, errorMessage) {
  var customErrorMessage = (0, _string.isString)(errorMessage) ? errorMessage : "";

  if (elementA && elementA instanceof HTMLElement) {
    elementA.setCustomValidity(customErrorMessage);
  }
};

var _default = setCustomError;
exports.default = _default;